import { formatNumber } from "@telerik/kendo-intl";
import React, { PureComponent } from "react";
import ReactApexChart from "react-apexcharts";
import "../../Styles/HistogramChart.scss";

export default class HistogramLineChart extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { pValueSeries: [], pValueOptions: {}, flag: true,sCurveValue:[] };
    this.chartRef = React.createRef();
  }

  constructlineChart = () => {
    let XandYaxis = [];
    if (
      this.props.histogramResponse.sCurevePercentage &&
      this.props.histogramResponse.sCurevePercentage.length > 0 &&
      this.props.histogramResponse.sCurveValue &&
      this.props.histogramResponse.sCurveValue.length > 0 && !this.props.histogramResponse.sCurveValue.every(val => val === 0)
    ) {
      XandYaxis = [[0, 0]];
      this.props.histogramResponse.sCurveValue.map((item, index) => {
        let pVal = this.props.histogramResponse.sCurevePercentage[index];
        XandYaxis.push([item, pVal]);
      });
    }
    this.setState({
      ...this.state,
      flag: false,
      sCurveValue:this.props.histogramResponse.sCurveValue,
      pValueSeries: [
        {
          name: "P",
          data: XandYaxis,
        },
      ],
      pValueOptions: {
        chart: {
          height: 380,
          width: "100%",
          type: "line",
          // background: '#1f2222',
          // foreColor: '#f1f1f1',
          // theme: {
          //   mode: 'dark',
          //   palette: 'palette1'
          // },
          toolbar: {
            show: false,
            tools: {
              download: true,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
              customIcons: [],
            },
          },
        },
        // Title is added only during export in the parent component
        stroke: {
          width: [3, 3, 6],
          curve: "smooth",
          lineCap: "square",
        },
        xaxis: {
          type: "numeric",
          tickAmount: 10,
          title: {
            text: this.props.histogramResponse.impactName,
            style: {
              color: this.props.isOpportunity ? "#bfbf2d" : "#00E396",
            },
          },
          labels: {
            formatter: function (value) {
              return formatNumber(value, "##,#");
            },
            rotate: -45,
            rotateAlways: true,
            axisTicks: {
              show: true,
            },
            labels: {
              show: true,
            },
            style: {
              colors: this.props.isOpportunity ? "#bfbf2d" : "#00E396",
              fontSize: "10px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 400,
              cssClass: "apexcharts-xaxis-label",
            },
          },
        },
        yaxis: {
          min: 0,
          max: 100,
          tickAmount: 10,
          title: {
            text: "P-Value (%)",
            style: {
              color: this.props.isOpportunity ? "#bfbf2d" : "#00E396",
            },
          },
          axisBorder: {
            show: true,
            color: this.props.isOpportunity ? "#bfbf2d" : "#00E396",
          },
          labels: {
            style: {
              colors: this.props.isOpportunity ? "#bfbf2d" : "#00E396",
            },
            formatter: function (value, index) {
              return value + "%";
            },
          },
          legend: {
            horizontalAlign: "left",
            offsetX: 40,
            labels: {
              colors: "#f1f1f1",
            },
          },
        },
        tooltip: {
          enabled: true,
          formatter: function (value) {
            return formatNumber(value, "##,#");
          },
          // theme: 'dark',
        },
        colors: [this.props.isOpportunity ? "#bfbf2d" : "#00E396", "#bfbf2d"],
      },
    });
  };

  render() {
    if (this.state.sCurveValue!==this.props.histogramResponse.sCurveValue) {
      this.constructlineChart();
    }
    return (
      <>
        <ReactApexChart
          ref={this.chartRef}
          options={this.state.pValueOptions ? this.state.pValueOptions : {}}
          series={this.state.pValueSeries ? this.state.pValueSeries : []}
          height={350}
        />
      </>
    );
  }
}
